var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoLineups(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39334 1L4.40718 3.25882C3.99834 3.47395 3.18067 4.35597 3.18067 6.16303V7.77647H5.78764V17.9412C5.78764 17.9412 8.39398 19 11.0003 19C13.6066 19 16.213 17.9412 16.213 17.9412V7.77647H18.819V6.16303C18.819 4.35597 18.0013 3.47395 17.5924 3.25882L13.607 1.00041L13.6066 1L13.6064 1.00005L13.6063 1L13.6063 1.00007C12.9379 1.1397 11.5349 1.34906 11.0003 1.34906C10.4657 1.34906 9.06227 1.13963 8.39398 1L8.39306 1.00102L8.39334 1Z",
    fill: "#FFBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 2.95475C10.3982 2.95475 8.86111 2.25663 8.39331 1C9.0616 1.13963 10.465 1.34906 10.9996 1.34906C11.5343 1.34906 12.9377 1.13963 13.606 1C13.1382 2.25663 11.6011 2.95475 10.9996 2.95475Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2349 8.49349L16.2122 4.58398V17.9415L15.2349 8.49349Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76489 8.49349L5.78752 4.58398V17.9415L6.76489 8.49349Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.69 6.625L12.2771 8.83477H11.911L11.506 6.625H10.4931L10.088 8.83477H9.72171L9.30884 6.625H8.18701L8.63891 8.83477H8.18701V10.0402H8.88813L9.34004 12.25H10.3529L10.8047 10.0402H11.1942L11.6461 12.25H12.659L13.1107 10.0402H13.812V8.83477H13.3601L13.812 6.625H12.69Z",
    fill: "#0A0B0F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoLineups);
export default __webpack_public_path__ + "static/media/picto-lineups.efdfa808ac89c5dc6e8ad14c29a665b7.svg";
export { ForwardRef as ReactComponent };